import { render, staticRenderFns } from "./waveHelpComponent.vue?vue&type=template&id=2348c6a4&scoped=true"
import script from "./waveHelpComponent.vue?vue&type=script&lang=js"
export * from "./waveHelpComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2348c6a4",
  null
  
)

export default component.exports